/* GEN THEORY tasarım çalıştırıcısı.
   Tasarım dosyalarındaki şablon dilini (bağlama [[yol]], sc-for, sc-if, onClick, ref, key)
   ve DCLogic bileşen sınıfını Preact ile birebir çalıştırır. */
(function () {
  var P = window.preact, h = P.h, render = P.render, Fragment = P.Fragment;

  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (patch) {
    if (typeof patch === 'function') patch = patch(this.state, this.props);
    this.state = Object.assign({}, this.state, patch);
    if (this.__schedule) this.__schedule();
  };
  window.DCLogic = DCLogic;

  var ONE = /^\[\[\s*([^\]]+?)\s*\]\]$/, ANY = /\[\[\s*([^\]]+?)\s*\]\]/g;
  function get(scope, path) {
    var v = scope, ks = path.split('.');
    for (var i = 0; i < ks.length; i++) {
      if (v == null) return undefined;
      var k = ks[i], G = window.GT;
      if (G && v[k] === undefined && v.name && k.indexOf('gt') === 0) {
        if (k === 'gtPrice') return G.price(v.name);
        if (k === 'gtUrl') return G.url(v.name);
        if (k === 'gtVid') return (G.find(v.name) || {}).v;
      }
      v = v[k];
    }
    return v;
  }
  function val(str, scope) {
    var m = str.match(ONE);
    if (m) return get(scope, m[1]);
    if (str.indexOf('[[') < 0) return str;
    return str.replace(ANY, function (_, p) { var v = get(scope, p); return v == null ? '' : String(v); });
  }

  function compile(node) {
    if (node.nodeType === 3) {
      var t = node.nodeValue;
      if (t.indexOf('[[') < 0) return function () { return t; };
      return function (s) { var v = val(t, s); return v == null ? '' : (typeof v === 'object' ? '' : String(v)); };
    }
    if (node.nodeType !== 1) return null;
    var tag = node.localName;
    var kids = [];
    var src = tag === 'template' ? node.content.childNodes : node.childNodes;
    for (var i = 0; i < src.length; i++) { var c = compile(src[i]); if (c) kids.push(c); }
    function children(s) { var out = []; for (var j = 0; j < kids.length; j++) out.push(kids[j](s)); return out; }

    if (tag === 'sc-for') {
      var list = node.getAttribute('list'), as = node.getAttribute('as') || 'item';
      return function (s) {
        var arr = val(list, s) || [];
        return arr.map(function (it, idx) {
          var sc = Object.create(s); sc[as] = it; sc[as + 'Index'] = idx;
          return h(Fragment, { key: idx }, children(sc));
        });
      };
    }
    if (tag === 'sc-if') {
      var cond = node.getAttribute('value');
      return function (s) { return val(cond, s) ? h(Fragment, null, children(s)) : null; };
    }

    var attrs = [];
    for (var a = 0; a < node.attributes.length; a++) {
      var at = node.attributes[a];
      if (at.name.indexOf('hint-') === 0) continue;
      attrs.push([at.name, at.value]);
    }
    return function (s) {
      var props = {};
      for (var k = 0; k < attrs.length; k++) {
        var n = attrs[k][0], v = val(attrs[k][1], s);
        if (n === 'class') n = 'class';
        if (n.indexOf('on') === 0 && typeof v !== 'function') continue;
        props[n] = v;
      }
      return h(tag, props, children(s));
    };
  }

  function propsOf(root) {
    var el = root.querySelector(':scope > script[data-props]');
    return el ? JSON.parse(el.textContent) : {};
  }

  function mount(root) {
    if (root.__gt) return;
    root.__gt = true;
    var tpl = root.querySelector(':scope > template:not([data-desk])');
    var codeEl = root.querySelector(':scope > script[type="text/x-dc"]');
    var host = root.querySelector(':scope > .gt-host');
    var Comp = codeEl ? new Function('DCLogic', codeEl.textContent + '\n;return typeof Component!=="undefined"?Component:null;')(DCLogic) : null;
    var inst = Comp ? new Comp(propsOf(root)) : new DCLogic(propsOf(root));
    function compileTpl(t) { var out = [], ns = t.content.childNodes; for (var i = 0; i < ns.length; i++) { var f = compile(ns[i]); if (f) out.push(f); } return out; }
    var fnsM = compileTpl(tpl), dt = root.querySelector(':scope > template[data-desk]'), fnsD = dt ? compileTpl(dt) : null;
    var mq = window.matchMedia('(min-width: 1024px)');
    function pick() { return fnsD && mq.matches ? fnsD : fnsM; }
    var fns = pick();
    root.classList.toggle('gt-desk', !!(fnsD && mq.matches));
    var queued = false;
    function draw() {
      var vals = inst.renderVals ? inst.renderVals() : {};
      var scope = Object.assign({}, inst.props, vals);
      render(h(Fragment, null, fns.map(function (fn) { return fn(scope); })), host);
    }
    if (fnsD) mq.addEventListener('change', function () { fns = pick(); root.classList.toggle('gt-desk', fns === fnsD); render(null, host); draw(); if (inst.onLayout) inst.onLayout(fns === fnsD); });
    inst.isDesk = function () { return !!fnsD && mq.matches; };
    inst.__schedule = function () { if (queued) return; queued = true; Promise.resolve().then(function () { queued = false; draw(); }); };
    root.__inst = inst;
    draw();
    root.classList.add('gt-ready');
    if (inst.componentDidMount) inst.componentDidMount();
  }

  function scale() {
    var vw = window.innerWidth || 390;
    var w = vw >= 1024 ? 390 : Math.min(vw, 480);
    document.documentElement.style.setProperty('--gtz', String(w / 390));
  }
  scale();
  window.addEventListener('resize', scale);

  function boot() { document.querySelectorAll('.gt-dc').forEach(mount); }
  window.GTDC = { mount: mount, boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
